import Root from './routes/root';
import './styles.css';
import './global.css';

function App() {
  return <Root />
}

export default App;
